import React, { ReactNode } from 'react';

const HomeContainer: React.FC<{ children: ReactNode }> = ({ children }) => {
	return (
		<div className="flex flex-col gap-12 lg:gap-24 w-full">
			{children}
		</div>
	);
};

export default HomeContainer;
